import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

import logoMp4 from '../../../../../video/guest/60sec.mp4';
import LogoIcon from '../../../icons/Logo';

import styles from '../../../../../styles/guest/sections/background/logo.module.scss';

import logo from '../../../../../img/logo.svg';
import logoWebm from '../../../../../video/guest/60sec.webm';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const Logo = ({ active, className }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (active) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    }, [active]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.active]: active,
                },
            ])}
        >
            <div className={styles.logoContainer}>
                <img className={styles.logo} src={logo} alt="Micromag" />
                <LogoIcon className={styles.logoInline} withoutO />
                <video className={styles.videoFrame} ref={videoRef} muted autoPlay loop playsInline>
                    <source src={logoMp4} type="video/mp4" />
                    <source src={logoWebm} type="video/webm" />
                </video>
            </div>
        </div>
    );
};

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;
